export default {
  methods: {
    widgetExplain(mttrinsight) {
      let senData = []
      for (let i = 0; i < mttrinsight.length; i++) {
        mttrinsight[i] = mttrinsight[i].replace(/\|/g, '').replace(/~/g, '');
        let Insitem = mttrinsight[i];
        if (Insitem.includes("trend") || Insitem.includes("Trend")) {
          var type = "fail";
          if (Insitem.includes("Backlog")) {
            type = "Backlog~"
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("Resolution Rate")) {
            type = "Resolution Rate~"
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("Incoming")) {
            type = "Incoming~"
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("Response") && Insitem.includes("SLA Violation %")) {
            type = "Response SLA Violation %~"
            type += Insitem.split('Response').pop().split('SLA')[0].trim() + "~";
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("exceeded Response SLAs")) {
            type = "exceeded Response SLAs~"
            type += Insitem.split('seen in').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("met Response SLAs")) {
            type = "met Response SLAs~"
            type += Insitem.split('seen in').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("Resolution") && Insitem.includes("SLA Violation %")) {
            type = "Resolution SLA Violation %~"
            type += Insitem.split('Resolution').pop().split('SLA')[0].trim() + "~";
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("exceeded Resolution SLAs")) {
            type = "exceeded Resolution SLAs~"
            type += Insitem.split('seen in').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("met Resolution SLAs")) {
            type = "met Resolution SLAs~"
            type += Insitem.split('seen in').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("Reopened")) {
            type = "Reopened~"
            type += Insitem.split('Reopened').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("Reassigned")) {
            type = "Reassigned~"
            type += Insitem.split('Reassigned').pop().split('tickets')[0].trim();
          } else if (Insitem.includes("MTTR")) {
            type = "MTTR~"
            type += Insitem.split('seen in').pop().split('MTTR')[0].trim() + "~";
            type += Insitem.split(' ')[1].trim().toLowerCase();
          } else if (Insitem.includes("MTTA")) {
            type = "MTTA~"
            type += Insitem.split('seen in').pop().split('MTTA')[0].trim() + "~";
            type += Insitem.split(' ')[1].trim().toLowerCase();
          }
          senData.push(type.trim());
        }
      }
      return senData
    },
  },
  mounted() {
  },
  unmounted() {
  },
}